import { routes } from '@routes';
import { Link } from 'react-router-dom';
import BG from './images/banner_bg.png';

export const YearEndSpecial = () => (
  <Link
    to={routes.contactSales.make()}
    onClick={() => window.scroll(0, 0)}
    className="group relative mb-3 flex min-w-0 flex-col items-start gap-4 overflow-hidden rounded-[10px] bg-gradient-to-r from-[var(--color-gradient-from)] to-[var(--color-gradient-to)] p-5 no-underline md:flex-row md:items-center md:justify-between md:gap-6 md:p-6"
  >
    <img src={BG} alt="" className="pointer-events-none absolute inset-0 h-full w-full object-fill" />
    <div className="relative min-w-0 text-[var(--color-fixed-white)]">
      <h2 className="text-xl font-semibold leading-tight md:text-3xl">AttorneyView is Now Live!</h2>
      <p className="mt-2 max-w-2xl text-sm leading-relaxed">
        Stream high-accuracy live transcripts securely to any participant on any device. Available exclusively through
        AutoScriptOne.
      </p>
    </div>
    <span className="relative inline-flex min-h-11 shrink-0 items-center justify-center rounded-[5px] border border-[var(--color-fixed-white)] px-4 text-sm font-medium text-[var(--color-fixed-white)] group-hover:bg-[var(--color-fixed-white)] group-hover:text-[var(--color-fixed-brand)]">
      Contact Us
    </span>
  </Link>
);
